<template>
  <div class="containerFull">
    <div class="wrapper-footer">
      <div class="footer-column" style="flex-direction:column">
        <h5 class="p-mb-4"><strong>Quality & Care</strong></h5>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d789.0357534045514!2d-74.05745968512205!3d4.684429520148251!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9aea5a58cdb5%3A0x835f056b3492b33d!2sQuality%20%26%20Care!5e0!3m2!1ses!2sco!4v1638792028673!5m2!1ses!2sco"
          style="border:0;width:100%;height:auto;"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
        <p class="p-mt-3 text-footer" style="text-align: justify;">
          {{ $t("messages.locationDescription") }}
        </p>
      </div>
      <!-- <div class="footer-column" style="flex-direction:column">
        <h5 class="p-mb-4"><strong> Más cerca de nosotros</strong></h5>
        <p class="social-media-link">
          <a href="https://www.facebook.com/profile.php?id=100092391947342&mibextid=LQQJ4d"
            target="_blank"
            ><img
              class="image-icon"
              src="@/assets/layout/icons/icon-facebook-24.png"
              alt="facebook-link"
            />Facebook</a
          >
        </p>        
        <p class="social-media-link">
          <a
            href="https://www.instagram.com/quality_care2023?igsh=aGd3M3Fvem53bW1s"
            target="blank"
            ><img
              class="image-icon"
              src="@/assets/layout/icons/icon-instagram-24.png"
              alt="instagram-link"
            />
            Instagram</a
          >
        </p>        
      </div> -->
      <div class="footer-column" style="flex-direction:column">
        <h5 class="p-mb-4"><strong>{{ $t("messages.featuredContent") }}</strong></h5>
        <ul style="padding-left: 0px;" class="text-footer">
          <template v-for="(itemMenu, index) in itemsMenu">
            <li v-if="itemMenu.items.length === 0" :key="index">
              <a class="linkMenu" :href="`${baseUrl}${itemMenu.to}`" >{{ $t(itemMenu.label) }}</a>
              <!-- <a class="linkMenu" @click="goTo(itemMenu)">{{ $t(itemMenu.label) }}</a> -->
            </li>
            <li v-for="(subitem) in itemMenu.items" :key="JSON.stringify(subitem)">
                  <a class="linkMenu" :href="`${baseUrl}${subitem.to}`" >{{
                    $t(subitem.label)
                  }}</a>

                  <!-- <a class="linkMenu" @click="goTo(subitem)">{{
                    $t(subitem.label)
                  }}</a> -->
                </li>
          </template>          
        </ul>
      </div>
      <div class="footer-column" style="flex-direction:column">
        <h5 class="p-mb-4"><strong>{{ $t("messages.contactData") }}</strong></h5>
        <p>Bogotá</p>
        <p class="text-footer"><a href="https://goo.gl/maps/qyKg5qVjL6wVkN1o9" target="blank">{{ $t("messages.addressUbication") }}{{ $t("messages.addressOfOffice") }}</a></p>
        <p class="text-footer"> <a href="tel:+576013849060">(601)3849060/61/62-69</a></p>
        <p class="text-footer"><a href="mailto:servicioalcliente@qualitycare.com.co">servicioalcliente@qualitycare.com.co</a></p>
        <p class="text-footer">{{ $t("messages.fullSchedule") }}</p>
        <p class="social-media-link">
          <a href="https://www.facebook.com/profile.php?id=100092391947342&mibextid=LQQJ4d"
            target="_blank"
            ><img
              class="image-icon"
              src="@/assets/layout/icons/icon-facebook-24.png"
              alt="facebook-link"
            /></a
          >
          <a
            href="https://www.instagram.com/quality_care2023?igsh=aGd3M3Fvem53bW1s"
            target="blank"
            ><img
              class="image-icon"
              src="@/assets/layout/icons/icon-instagram-24.png"
              alt="instagram-link"
            /></a
          >
        </p> 
      </div>
    </div>

    <div class="lastfooter">
      <a class="LinkLastfooter" href="mailto:albertojruizm@gmail.com"
        ><span>desarrollado por alberuizmo</span></a
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "footerX",
  data() {
    return {
      baseUrl:process.env.VUE_APP_BASE_URL,
      linkMapa: "https://goo.gl/maps/uQn1CMFhVDyDqhwT8",
      htmlMapa:
        '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d700.8876138737825!2d-74.05727343647617!3d4.684929287819055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9b2777c4bc75%3A0x9735189d6d69f24e!2sClinica%20Dali%20Bogota!5e0!3m2!1ses!2sco!4v1637955671370!5m2!1ses!2sco" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>',
    };
  },
  methods: {
    goTo(itemMenu) {
      this.$router.push(itemMenu.to).catch(() => {});
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  computed: {
    ...mapGetters(["getUserData", "itemsMenu"]),
  },
};
</script>

<style scoped>
.containerFull {
  background-color: #0a152c;
}

.wrapper-footer {
  width: 100%;
  padding: 40px 15%;
  display: flex;
  flex-wrap: wrap;
}

.footer-column {
  width: 33.33%;
  padding: 0px 30px;
  display: flex;
  flex-wrap: wrap;
  color: #a3b3da;
}

.parrafo-footer {
  width: 100%;
}

.lastfooter {
  text-align: center;
}

.LinkLastfooter {
  color: #919191;
  font-size: 12px;
}

.LinkLastfooter:link,
.LinkLastfooter:visited,
.LinkLastfooter:active {
  text-decoration: none !important;
}

li {
  list-style: none;
  padding-bottom: 3px;
}

a {
  color: #a3b3da;
  text-decoration: none;
  cursor: pointer;
  user-select: none;
  transition: 0.5s all;
}
a:hover {
  color: #dadde4;
  padding-left: 5px;
}
.social-media-link {
  transition: 0.5s all;
  cursor: pointer;
}

.text-footer{
  font-size: 1.2rem;
}

.image-icon{
  height: 40px;
  width: 40px;
}

/* .social-media-link:hover {
  color: #dadde4;
  padding-left: 5px;
} */
@media screen and (max-width: 1450px) {
  .wrapper-footer {
    padding: 40px 5%;
  }
}
@media screen and (max-width: 1200px) {
  .wrapper-footer {
    padding: 40px 10px;
  }
  .footer-column {
    padding: 0px 10px;
    margin-bottom: 50px;
  }
}
@media screen and (max-width: 750px) {
  .wrapper-footer {
    padding: 20px 10px;
  }
  .footer-column {
    width: 100%;
  }
}
</style>
